import { useEffect } from 'react'
import CIMSBadge from '../../../../CIMSBadge'
import { Count } from '../types'

const CountItem: React.FC<Count> = ({
  children,
  key,
  count,
  onCountChange,
  ...rest
}) => {
  useEffect(() => {
    onCountChange?.({ key, count })
    // don't include onCountChange to avoid infinite re-renders
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [count, key])
  if (!count && rest.showZero === false) return null
  return (
    <CIMSBadge count={count} {...rest}>
      {children}
    </CIMSBadge>
  )
}

export default CountItem
